module.exports = __webpack_public_path__ + "img/media-nga.fb1c7a8d.png";